/**
 * @file environment.development.ts
 * @description Development environment configuration — swapped in for
 * `environment.ts` when the `development` Angular configuration is
 * selected (see `project.json` fileReplacements).
 *
 * Cognito pool IDs and auth domain are public identifiers (not secrets).
 * They identify which user pool to authenticate against but cannot be
 * used alone to access data, so they are safe to commit for the dev
 * environment.
 *
 * The Paddle token below is a placeholder — replace with a real sandbox
 * token from the Paddle dashboard when commercial flows are tested in dev.
 */
import type { Environment } from './environment.model';

export const environment: Environment = {
  stage: 'dev',
  production: false,
  // apiBaseUrl: 'https://api-dev.kirigami.ai/v1',
  apiBaseUrl: 'http://127.0.0.1:8000/v1',
  kbapiBaseUrl: 'https://kbapi-dev.kirigami.ai/v1',
  gtm_id: 'GTM-KGZTTFW3',
  cognito: {
    userPoolId: 'eu-west-1_SY9uhVt9d',
    pubClientId: '2b26824ucicbcs2qdppkm198vc',
    priClientId: '1ssosn0nhc11m4u9s9ugb80gpb',
    region: 'eu-west-1',
    domain: 'auth-dev.kirigami.ai',
    responseType: 'code',
    scope: 'email openid profile phone aws.cognito.signin.user.admin',
  },
  // TODO [INTEGRATION]: Replace placeholder with real Paddle sandbox token + price IDs
  paddle: {
    token: 'test_43b302f4f1790bad59320f529ba',
    priceId_1: 'pri_01kpv071sdwgksfgxzr44e4yry',
    priceId_2: 'pri_01k82xw4njskpe54gzsv96srtd',
    priceId_3: 'pri_01k82xxmwzrebqsb40g6qpa0kj',
    // Token product (subscription, $20/mo, kirigami_tokens=10,000,000) — same
    // product as Researcher Monthly below.
    priceId_tokens: 'pri_01kvakb4db8v8j7s0gzcm1qr9y',
    // Subscription plans (Paddle SANDBOX). Monthly + annual price ids per plan.
    priceId_researcher_monthly: 'pri_01kvakb4db8v8j7s0gzcm1qr9y', // $20/mo
    priceId_researcher_annual: 'pri_01kvv6z0r69h3m9hcxvs76nx16', // $216/yr
    priceId_researcher_pro_monthly: 'pri_01kvv7cb4nvamvy03x5te1p90y', // $35/mo
    priceId_researcher_pro_annual: 'pri_01kvv7grrhwg5xw0yakx1ftgyg', // $378/yr
    priceId_mini_lab_monthly: 'pri_01kvv7p68xke1dz3cy58vn81m1', // $70/mo
    priceId_mini_lab_annual: 'pri_01kvv7t4rrsk4223c5j3etgqw0', // $168/yr
  },
};
